import { render, staticRenderFns } from "./TestPaper.vue?vue&type=template&id=e26701ec&scoped=true&"
import script from "./TestPaper.vue?vue&type=script&lang=js&"
export * from "./TestPaper.vue?vue&type=script&lang=js&"
import style0 from "./TestPaper.vue?vue&type=style&index=0&id=e26701ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26701ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
